import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link as RouterLink } from 'react-router';
import { ButtonV2, Link } from '@zola/zola-ui';

import { hideModal } from '../../../actions/ModalActions';
import importImages from '../../../util/webpack';

const modalImages = importImages(
  require.context('../../../assets/images/doodles/', false, /\.(jpg|jpeg|png|gif|svg)(\?.*)?$/)
);

const PublishRsvpModal = props => {
  const { closeModal } = props;

  return (
    <div id="publish-rsvp-modal" className="publish-share-modal text-center">
      <div className="modal-header">
        <img
          src={modalImages('namecardWithName')}
          srcSet={modalImages('namecardWithName')}
          alt="namecard doodle"
        />
        <h2>You are using Online RSVP</h2>
      </div>
      <div className="modal-body">
        <p className="body-text">
          A quick reminder: only guests you&#39;ve added to Guest List and{' '}
          <br className="hidden-xs" />
          marked as &#34;Definitely&#34; invited can RSVP on your wedding website.
        </p>
        <p className="body-text">
          Guests not added to Guest List or marked as &#34;Maybe&#34; <br className="hidden-xs" />
          invited will not be able to RSVP online.
        </p>
        <div className="actions">
          <RouterLink
            to="/wedding/manage/guests/all"
            onClick={closeModal}
            role="button"
            className="v2-button primary-button btn-left"
          >
            See Guest List
          </RouterLink>
          <ButtonV2 onClick={closeModal} className="v2-button secondary-button btn-right">
            Got It
          </ButtonV2>
        </div>
        <p className="footer-text">
          Not sure how online RSVP works?{' '}
          <Link
            arrow
            className="text-button"
            href="https://help.zola.com/hc/en-us/articles/115002251631-How-do-I-set-up-online-RSVPs-"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn More
          </Link>
        </p>
      </div>
    </div>
  );
};

PublishRsvpModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  slug: state.wedding.wedding.slug,
});

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(hideModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PublishRsvpModal);



// WEBPACK FOOTER //
// ./src/components/manage/website/PublishRsvpModal.jsx